export function push(error: any, errors = []): [string] | never[] {
  return errors.concat(error)
}
